module.exports = __webpack_public_path__ + "img/18.77513d98.jpg";